import { Component, type ReactNode } from "react";

/** A crash in one screen shows a way out instead of a blank page. */
export class ErrorBoundary extends Component<{ children: ReactNode; resetKey?: string }, { error: Error | null }> {
  state = { error: null as Error | null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error) {
    console.error("Screen crashed:", error);
  }

  componentDidUpdate(prev: { resetKey?: string }) {
    if (prev.resetKey !== this.props.resetKey && this.state.error) this.setState({ error: null });
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="auth" role="alert">
        <h2>Something went wrong on this screen</h2>
        <p className="muted small">If the server was just updated, reloading usually fixes it.</p>
        <p className="m xs muted">{this.state.error.message}</p>
        <button className="btn btn-primary btn-block" onClick={() => location.reload()}>Reload</button>
        <a className="btn btn-block" href="/">Back to my space</a>
      </div>
    );
  }
}
